"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty2 = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports.cleanAgentMetadata = cleanAgentMetadata;
exports.mapMember = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/define-property"));

var _defineProperties = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/define-properties"));

var _getOwnPropertyDescriptors = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors"));

var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));

var _getOwnPropertyDescriptor = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor"));

var _getOwnPropertySymbols = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));

var _slice = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/slice"));

var _set = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/set"));

var _from = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/array/from"));

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));

var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));

var _defineProperty3 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _reduce = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/reduce"));

var _helpers = require("./utils/helpers");

function ownKeys(object, enumerableOnly) { var keys = (0, _keys.default)(object); if (_getOwnPropertySymbols.default) { var symbols = (0, _getOwnPropertySymbols.default)(object); if (enumerableOnly) symbols = (0, _filter.default)(symbols).call(symbols, function (sym) { return (0, _getOwnPropertyDescriptor.default)(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context6; (0, _forEach.default)(_context6 = ownKeys(Object(source), true)).call(_context6, function (key) { (0, _defineProperty3.default)(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors.default) { (0, _defineProperties.default)(target, (0, _getOwnPropertyDescriptors.default)(source)); } else { var _context7; (0, _forEach.default)(_context7 = ownKeys(Object(source))).call(_context7, function (key) { (0, _defineProperty2.default)(target, key, (0, _getOwnPropertyDescriptor.default)(source, key)); }); } } return target; }

var mapMember = function mapMember(data) {
  var _context;

  var id = data.id,
      _data$name = data.name,
      name = _data$name === void 0 ? '' : _data$name,
      _data$firstName = data.firstName,
      firstName = _data$firstName === void 0 ? '' : _data$firstName,
      _data$lastName = data.lastName,
      lastName = _data$lastName === void 0 ? '' : _data$lastName,
      _data$email = data.email,
      email = _data$email === void 0 ? {} : _data$email,
      _data$phones = data.phones,
      phones = _data$phones === void 0 ? [] : _data$phones,
      _data$profile = data.profile;
  _data$profile = _data$profile === void 0 ? {} : _data$profile;

  var _data$profile$socialL = _data$profile.socialLinks,
      socialLinks = _data$profile$socialL === void 0 ? [] : _data$profile$socialL,
      _data$profile$photos = _data$profile.photos,
      _photos = _data$profile$photos === void 0 ? [] : _data$profile$photos,
      _data$profile$text = _data$profile.text,
      text = _data$profile$text === void 0 ? '' : _data$profile$text,
      _data$testimonials = data.testimonials,
      testimonials = _data$testimonials === void 0 ? [] : _data$testimonials,
      _data$organisations = data.organisations,
      organisations = _data$organisations === void 0 ? [] : _data$organisations,
      _data$teams = data.teams,
      teams = _data$teams === void 0 ? [] : _data$teams,
      nameInAnotherLanguage = data.nameInAnotherLanguage,
      _data$awards = data.awards,
      awards = _data$awards === void 0 ? [] : _data$awards,
      _data$currentRecognit = data.currentRecognition,
      currentRecognition = _data$currentRecognit === void 0 ? [] : _data$currentRecognit,
      _data$recognition = data.recognition,
      recognition = _data$recognition === void 0 ? [] : _data$recognition,
      eliteMember = data.eliteMember,
      principal = data.principal,
      _data$typeCode = data.typeCode,
      typeCode = _data$typeCode === void 0 ? '' : _data$typeCode,
      userName = data.userName,
      webSite = data.webSite;

  var photos = (0, _helpers.mapPhotos)(_photos);
  var contact = (0, _helpers.mapPhones)(phones);
  var social = (0, _helpers.mapSocials)(socialLinks);
  var orgMap = (0, _reduce.default)(organisations).call(organisations, function (acc, org) {
    return _objectSpread(_objectSpread({}, acc), {}, {
      [org.id]: org
    });
  }, {});
  var teamMap = (0, _reduce.default)(teams).call(teams, function (acc, team) {
    return _objectSpread(_objectSpread({}, acc), {}, {
      [team.id]: team
    });
  }, {});
  var givenName = firstName || name.split(/\s+/).shift() || '';
  var surname = lastName || name.replace(givenName, '').replace(/(^\s+|\s+$)/g, '');
  var fullName = name || (0, _filter.default)(_context = [givenName, surname]).call(_context, function (x) {
    return x;
  }).join(' ');
  return {
    id,
    memberId: id,
    fullName,
    givenName,
    surname,
    email: email.hidden ? undefined : email.address,
    contactEmail: email.address,
    primaryPhone: contact.primary,
    primaryPhoneLocal: contact.primaryLocal,
    mobilePhone: contact.mob,
    mobilePhoneLocal: contact.mobLocal,
    officePhone: contact.fix,
    officePhoneLocal: contact.fixLocal,
    promoPhone: contact.promo,
    promoPhoneLocal: contact.promoLocal,
    fax: contact.fax,
    faxLocal: contact.faxLocal,
    imageHeadshot: photos.mphs,
    imageLifestyle: photos.mpls,
    description: text,
    testimonials,
    title: organisations[0] ? organisations[0].title : '',
    isPrincipal: !!principal,
    titles: (0, _reduce.default)(organisations).call(organisations, function (titles, _ref) {
      var _id = _ref.id,
          title = _ref.title;
      titles[_id] = title; // eslint-disable-line no-param-reassign

      return titles;
    }, {}),
    phones: (0, _reduce.default)(organisations).call(organisations, function (acc, _ref2) {
      var _id = _ref2.id,
          _ref2$phones = _ref2.phones,
          _phones = _ref2$phones === void 0 ? [] : _ref2$phones;

      var mapped = (0, _helpers.mapPhones)(_phones); // eslint-disable-next-line no-param-reassign

      acc[_id] = {
        primaryPhone: mapped.primary,
        primaryPhoneLocal: mapped.primaryLocal,
        mobilePhone: mapped.mob,
        mobilePhoneLocal: mapped.mobLocal,
        officePhone: mapped.fix,
        officePhoneLocal: mapped.fixLocal,
        promoPhone: mapped.promo,
        promoPhoneLocal: mapped.promoLocal,
        fax: mapped.fax,
        faxLocal: mapped.faxLocal
      };
      return acc;
    }, {}),
    facebook: social.facebook,
    twitter: social.twitter,
    googlePlus: social.google,
    youtube: social.youtubechannel,
    linkedin: social.linkedin,
    pinterest: social.pinterest,
    instagram: social.instagram,
    video: social.videoprofile,
    organisations: orgMap,
    organisationIds: (0, _map.default)(organisations).call(organisations, function (org) {
      return org.id;
    }),
    teams: teamMap,
    // NOTE(@elyobo): Teams may appear more than once due to one entry per role.
    teamIds: (0, _from.default)(new _set.default((0, _map.default)(teams).call(teams, function (team) {
      return team.id;
    }))),
    alternateName: nameInAnotherLanguage,
    awards: (0, _helpers.cleanupAwards)(awards),
    recognitionLevels: currentRecognition,
    allRecognitionLevels: recognition,
    isElite: !!eliteMember,
    isServiceAccount: (0, _slice.default)(typeCode).call(typeCode, -2) === 'SA',
    isCorporate: typeCode === 'CORP' || typeCode === 'CORSA',
    userName,
    website: webSite
  };
};

exports.mapMember = mapMember;

function cleanAgentMetadata(data) {
  var _context2;

  var total = data.hits.total,
      _typeCodes = data.aggregations.typeCodes;
  /* eslint-disable no-shadow, prefer-arrow-callback, no-param-reassign, func-names */

  var typeCode = (0, _reduce.default)(_context2 = _typeCodes.buckets).call(_context2, function (previous, current) {
    var _context3, _context5;

    var key = current.key,
        _subTypeCode = current.subTypeCode,
        _statusCode = current.statusCode;
    var subTypeCode = (0, _reduce.default)(_context3 = _subTypeCode.buckets).call(_context3, function (previous, current) {
      var _context4;

      var key = current.key,
          total = current.doc_count,
          _statusCode = current.statusCode;
      var statusCode = (0, _reduce.default)(_context4 = _statusCode.buckets).call(_context4, function (previous, current) {
        previous[current.key] = {
          total: current.doc_count
        };
        return previous;
      }, {});
      previous[key] = {
        total,
        statusCode
      };
      return previous;
    }, {});
    var statusCode = (0, _reduce.default)(_context5 = _statusCode.buckets).call(_context5, function (previous, current) {
      previous[current.key] = {
        total: current.doc_count
      };
      return previous;
    }, {});
    previous[key] = {
      subTypeCode,
      statusCode
    };
    return previous;
  }, {});
  /* eslint-disable no-shadow, prefer-arrow-callback, no-param-reassign, func-names */

  return {
    typeCode,
    total
  };
}